import { render, staticRenderFns } from "./faq_restaurateur.vue?vue&type=template&id=6e5274b4&scoped=true&"
import script from "./faq_restaurateur.vue?vue&type=script&lang=js&"
export * from "./faq_restaurateur.vue?vue&type=script&lang=js&"
import style1 from "./faq_restaurateur.vue?vue&type=style&index=1&id=6e5274b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5274b4",
  null
  
)

export default component.exports